<template>
    <AddFiliereNiveauMatiere />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import AddFiliereNiveauMatiere from "@/components/FiliereNiveauMatiere/AddFiliereNiveauMatiere.vue";
  
    export default defineComponent({
      name: "AddFiliereNiveauMatierePage",
      components: {
        AddFiliereNiveauMatiere,
      },
    });
  </script>